<template lang="pug">
.rich-text-wrapper
  ValidationProvider(name="Lange Beschreibung" :rules="rules" v-slot="{ errors, valid }")
    b-field(label="Lange Beschreibung" label-position="on-border"
            :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
      vue-editor(v-model="innerValue"
                  :editorOptions="editorOptions")
</template>

<script>
export default {
  props: {
    rules: {
      type: [Object, String],
      default: "required"
    },
    value: {
      type: null
    }
  },
  data() {
    return {
      innerValue: "",
      editorOptions: {
        placeholder: "Bitte füllen Sie dieses Feld aus ...",
        theme: "snow",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike", "link"], // toggled buttons
            ["blockquote"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }], // superscript/subscript
            [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            [{ align: [] }],

            ["clean"] // remove formatting button
          ]
        }
      }
    };
  },
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit("input", newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
    }
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  }
};
</script>

<style lang="scss" scoped>
.rich-text-wrapper {
  margin: $sm-space 0 $xs-space 0;
}
</style>